import { storageConstants } from 'src/utils/constants/storageConstants';

import { StandardBasicCampus } from 'src/types/standard-basic-campus';

/**
 * Standard Basic Campus 데이터를 로컬 스토리지에 저장하는 함수
 *
 * @param data - Standard Basic Campus 데이터
 */
export const saveStandardBasicCampusToStorage = (data: StandardBasicCampus): void => {
  // 로컬 스토리지에 brandcode, companyName, socialCode, brandName, brandLogo 저장
  localStorage.setItem(storageConstants.brandCode, data.code);
  localStorage.setItem(storageConstants.browserTitle, data.companyName);
  document.title = data.companyName;
  localStorage.setItem(storageConstants.socialCode, JSON.stringify(data.social));
  localStorage.setItem(storageConstants.brandName, data.name);
  localStorage.setItem(storageConstants.brandLogo, data.logo);
};

/**
 * 로컬 스토리지에서 Standard Basic Campus 데이터를 제거하는 함수
 */
export const clearStandardBasicCampusFromStorage = (): void => {
  localStorage.removeItem(storageConstants.brandCode);
  localStorage.removeItem(storageConstants.browserTitle);
  localStorage.removeItem(storageConstants.socialCode);
  localStorage.removeItem(storageConstants.brandName);
  localStorage.removeItem(storageConstants.brandLogo);

  // 브라우저 타이틀도 초기화
  document.title = '';
};
